//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _importRelation from './importRelation';
export const importRelation = _importRelation;
export default {importRelation};

